<template>
  <div class="codes-history-panel">
    <div class="codes-history-panel__tabs-wrap">
      <v-tabs
        v-model="activeTab"
        class="codes-history-panel__tabs"
        grow
      >
        <v-tab
          v-for="item in visibleItems"
          :key="item.value"
          class="codes-history-panel__tab"
        >
          {{ item.text }}
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="activeTab" class="codes-history-panel__tabs-items">
      <v-tab-item
        v-for="item in visibleItems"
        :key="item.value"
      >
        <TempCodeProvisionHistoryJournal
          v-if="item.value === 'temp'"
          :doorphone-id="doorphoneId"
          :include-doorphone-address="includeDoorphoneAddress"
        />
        <ServiceDoorCodeHistoryJournal
          v-else-if="item.value === 'service'"
          :doorphone-id="doorphoneId"
          :include-doorphone-address="includeDoorphoneAddress"
          title="Журнал сервисного кода"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import TempCodeProvisionHistoryJournal from './TempCodeProvisionHistoryJournal.vue';
import ServiceDoorCodeHistoryJournal from './ServiceDoorCodeHistoryJournal.vue';

export default {
  name: 'CodesHistoryPanel',
  components: {
    TempCodeProvisionHistoryJournal,
    ServiceDoorCodeHistoryJournal,
  },
  props: {
    doorphoneId: {
      type: [Number, String],
      default: null,
    },
    includeDoorphoneAddress: {
      type: Boolean,
      default: false,
    },
    tempRoute: {
      type: String,
      required: true,
    },
    serviceRoute: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      activeTab: 0,
    };
  },
  computed: {
    items () {
      return [
        {
          text: 'Выданные коды',
          value: 'temp',
          route: this.tempRoute,
        },
        {
          text: 'Сервисный код',
          value: 'service',
          route: this.serviceRoute,
        },
      ];
    },
    visibleItems () {
      return this.items.filter((item) => this.$canRoute(item.route));
    },
  },
  watch: {
    visibleItems: {
      immediate: true,
      handler (items) {
        if (!items.length) {
          this.activeTab = 0;
          return;
        }
        if (this.activeTab >= items.length) {
          this.activeTab = 0;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.codes-history-panel__tabs-wrap {
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.codes-history-panel__tabs {
  box-shadow: none;
}

.codes-history-panel__tabs ::v-deep .v-tabs-bar {
  background: transparent;
  height: 48px;
}

.codes-history-panel__tabs ::v-deep .v-tab {
  text-transform: none;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #546e7a;
  min-height: 48px;
  letter-spacing: 0;
}

.codes-history-panel__tabs ::v-deep .v-tab--active {
  color: #1976d2;
}

.codes-history-panel__tabs ::v-deep .v-tabs-slider {
  color: #1976d2;
  height: 3px;
}

.codes-history-panel__tabs ::v-deep .v-tab:not(.v-tab--active):hover {
  color: #37474f;
}

.codes-history-panel__tabs-items {
  background: transparent;
}
</style>
